import { errorStatusMessage } from './errorStatusMessage';
import { sportHistory } from './sportHistory';
import { reports } from './reports';
import { rankTypes } from 'features/ranking/data';
import { assistantPanel } from './assistantPanel';

export const locale = {
  ...errorStatusMessage,
  reports,
  sportHistory,
  assistantPanel,
  change: 'Cambiar',
  changePassword: 'Cambiar contraseña',
  logout: 'Cerrar sesión',
  transferOfFunds: 'Transferencia de fondos',
  withdrawalOfFunds: 'Retiro de fondos',
  access: 'Acceder',
  agentPlatfrom: 'Plataforma de agentes',
  email: 'Correo electrónico',
  password: 'Contraseña',
  orderOfPlay: 'Orden de juego',
  login: 'Usuario',
  other: 'Los demás',
  username: 'Nombre de usuario',
  language: 'Idioma',
  captchaCouldNotBeVerified: 'No se pudo verificar la CAPTCHA. Por favor, intentalo de nuevo.',
  captchaCooldownMessage: seconds => `Intentalo de nuevo en ${seconds}s.`,
  confirmNewPassword: 'Confirmar nueva contraseña',
  changeMyPassword: 'Cambiar mi contraseña',
  back: 'Atrás',
  statuses: {
    1: 'Ganado',
    2: 'Perdido',
    3: 'Espera',
  },

  generalReport: 'Informe General',
  depositsAndWithdrawals: 'Depositos/Retiros Jugadores',
  playerAndAgentDetail: 'Detalles de jugadores y agentes',
  agents: 'Agentes',
  agent: 'Agente',
  confirmPassword: 'Confirmar contraseña',
  emtretenimiento: 'Somos emtretenimiento',
  users: 'Usuarios',
  seeAll: 'Ver todo',
  seeAgents: 'Ver agentes',
  seePlayers: 'ver jugadores',
  createAgent: 'Crear agente',
  createPlayer: 'Crear jugador',
  gameTypes: {
    slots: 'Tragamonedas',
    liveCasino: 'Casino en Vivo',
    crashGames: 'Juegos Crash',
    virtualGames: 'Juegos Virtuales',
  },
  games: 'Juegos',
  game: 'Juego',
  assistant: 'Asistente',
  assistantGanamos: 'Asistente Ganamos',
  financialReports: 'Reportes financieros',
  general: 'General',
  cashDepositsWithdrawals: 'Efectivo (depósitos y retiros)',
  playerReports: 'Informes de jugadores',
  playerHistory: 'Historial de jugadores',
  detailByPlayer: 'Detalle por jugador',
  sportsBets: 'Apuestas Deportivas',
  finance: 'Finanzas',
  myDebtAccount: 'Depositos/Retiros Agentes',
  payments: 'Pagos',
  buyBalance: 'Depositar',
  paymentAmountUsdt: 'Monto a depositar en USDT',
  enterAmountUsdt: 'Ingrese el importe en USDT',
  maxAmountUsdt: 'El monto máximo es de {amount} USDT',
  depositBalance: 'Depositar USDT',
  balancePurchase: 'Recarga de saldo',
  topUpInformation: 'Información de la recarga',
  paymentNetwork: 'Red',
  topUpAddress: 'Dirección',
  topUpAmountUsdt: 'Monto (USDT)',
  forfeitNote:
    '¡Importante! Cualquier monto superior a {amount} USDT se perderá y no será acreditado a tu saldo.',
  paymentTimer: 'Tiempo restante',
  sendUsdtInstruction:
    'Enviá {amount} USDT a la dirección indicada a través de la red USDT-TRC20 y luego hacé clic en «Ya envié».',
  iSent: 'Ya envié',
  waitingForPayment: 'Esperando la confirmación del pago.',
  fundsWillIncrease: 'Una vez acreditados los fondos, tu saldo se actualizará.',
  timeLeft: 'Tiempo restante',
  paymentSuccess: '¡Listo!',
  fundsCredited: 'Los fondos ya fueron acreditados.',
  youMayClosePage: 'Ya podés cerrar esta página.',
  elapsedTime: 'Tiempo transcurrido',
  topUpMore: 'Recargar más saldo',
  failedToTopUp: 'No se pudo completar la recarga.',
  topUpAgain: 'Intentar de nuevo',
  accountBalance: 'Saldo de la cuenta',
  howToStart: 'Cómo empezar',
  returnBack: 'Volver atrás',
  search: 'Buscar',
  newAgent: 'Nuevo agente',
  gameNameSearch: 'Nombre del juego',
  newPlayer: 'Nuevo jugador',
  player: 'Jugador',
  pending: 'Pendiente',
  none: 'Ninguno',
  approved: 'Aprobado',
  rejected: 'Rechazado',
  providersDetails: 'Solicitud de cambio de proveedor',
  gamesDetails: 'Solicitud de cambio de juegos',
  agentId: 'ID de agente',
  agentStructure: 'Estructura del agente',
  requestType: 'Tipo de solicitud',
  requestDate: 'Fecha de solicitud',
  lastMonthNetwin: 'Ganancia neta del último mes',
  confirm: 'Confirmar',
  reject: 'Rechazar',
  myStatistic: 'Mis Estadísticas',
  totalWin: 'Ganacias totales',
  totalNetwin: 'Total Netwin',
  margin: 'Margen',
  myAgents: 'Mis agentes',
  myPlayers: 'Mis jugadores',
  playerBalance: 'Saldo de jugadores',
  agentBalance: `Saldo de agentes`,
  before: 'Antes',
  after: 'Después',
  number: 'Número',
  netwin: 'Netwin',
  bets: 'Apuestas',
  wins: 'Ganancias',
  id: 'Id',
  totalBets: 'Apuestas totales',
  activeUser: 'Usuarios activos',
  noResultsFound: 'No se han encontrado resultados',

  game: 'Juego',
  socialMedia: 'Redes sociales',
  notification: 'Notificación',

  allUsers: 'Todos usuarios',
  players: 'Jugadores',
  disabled: 'Desactivado',
  user: 'Usuario',
  balance: 'Saldo',
  operations: 'Operaciones',
  actions: 'Acciones',
  records: 'Registros',
  recordsOnPage: 'Mostrar en la página',
  elementsOnPage: 'Elementos en la página',
  balanceSort: 'Ordenar por balance',
  none: 'Sin ordenar',
  moreToLess: 'De mayor a menor',
  lessToMore: 'De menor a mayor',
  aToz: 'A to Z',
  zToa: 'Z to A',
  withdrawal: 'Retiro',
  deposit: 'Depósito',
  toDeposit: 'Depósito',
  topup: 'Depositar',
  cancel: 'Cancelar',
  save: 'Guardar',

  name: 'Nombre',
  filter: 'Filtro',
  acceptFilter: 'Aplicar filtro',

  surname: 'Apellido',
  withdrawalAllowed: 'Permitir <span>retiros</span> para sus agentes y jugadores',
  depositAllowed: 'Permitir <span>depósitos</span> para sus agentes y jugadores',
  onlyPlayerCreationAllowed: 'Permitir la <span>creación</span> de solo jugadores',
  isHigherAgentsOperationsRestricted: 'Permitir operaciones de agentes superiores a mis usuarios',
  createSuccess: 'Éxito',
  amount: 'Monto',

  disable: 'Bloquear',
  edit: 'Editar',
  userEdit: 'Editar',
  informations: 'Información',
  id: 'ID',
  accept: 'Aceptar',
  disableUser: 'Bloquear Usario',
  acceptDisableUser: 'Sí, bloquearlo',
  acceptEnableUser: 'Sí, habilitar usuario',
  disableDescription: 'Está seguro de que desea bloquear el jugador con el nombre',
  enableDescription: 'Está seguro de que desea habilitar el reproductor <br/> con nombre de usuario',

  modifyAgent: 'Modificar agente',
  information: 'Información',
  hierachy: 'jerarquía',
  currency: 'Moneda',
  creationDate: 'Fecha de creación',
  modificationDate: 'Fecha de modificación',
  enable: 'Habilitar',
  enableUser: 'Habilitar usuario',
  close: 'Cerrar',
  noResults: 'No se encontraron resultados',

  today: 'Hoy',
  yesterday: 'Ayer',
  last7Days: 'Últimos 7 días',
  last30Days: 'Últimos 30 días',
  lastWeek: 'La semana pasada',
  lastMonth: 'El mes pasado',
  dateFrom: 'Fecha desde',
  dateTo: 'Fecha hasta',
  local: 'Local',
  utc: 'UTC',
  dateUntil: 'Fecha hasta',
  help: 'Ayuda',
  show: 'Mostrar',
  directOnly: 'Solo directos',
  timeZoneMsg:
    'La zona horaria local tiene en cuenta la fecha y la hora que ha configurado en su dispositivo. La zona horaria UTC 00:00 es un estándar de tiempo universal. Si selecciona la opción "Local", se tendrá en cuenta la hora de su país, y si selecciona la opción "UTC", se tendrá en cuenta la hora estándar universal.',
  10: '10',
  total_bet_count: 'Recuento total de apuestas',
  total_bet: 'Apuesta total',
  total_won: 'Total ganado',
  betCount: 'Recuento de apuestas',
  betAmount: 'Monto de la apuesta',
  commission_balance: 'Comisión',
  winAmount: 'Cantidad ganada',
  provider: 'Proveedor',

  searchIn: 'Busca en',
  higher: 'Más alto',
  transaction: 'Transacción',
  date: 'Fecha',
  operation: 'Operación',
  transitionType: 'Tipo de transición',
  agentInitiator: 'Agente iniciador',
  initiator: 'Iniciador',
  destinationAgent: 'Agente de destino',

  reportsGeneral: 'Informes generales',
  playerReportsGeneral: 'Informes de jugadores generales',
  sportBets: 'Apuestas Deportivas',
  amountIn: 'Depositado',
  amountOut: 'Retirado',
  total: 'Balance actual',
  totalSaldo: 'Total',
  byProvider: 'Por proveedor',
  myOperations: 'Mis operaciones',
  result: 'Resultado',

  gameType: 'Tipo de juego',
  statusBet: 'Apuesta de estado',
  type: 'Tipo',
  win: 'Ganado',
  bet: 'Apuesta',
  refund: 'Reembolso',
  liveCasino: 'Casino en vivo',
  virtualGames: 'Juegos virtuales',
  all: 'Todos',
  slots: 'Tragamonedas',
  status: 'Estado',
  prevBalance: 'Saldo antes',
  balanceAfter: 'Saldo después',
  balanceBefore: 'Saldo antes',
  prevBefore: 'Saldo ante',
  afterBalance: 'Saldo después',
  userId: 'Identificación de usuario',
  couponId: 'identificación del cupón',
  wait: 'En espera',
  return: 'Devuelto',
  loss: 'Pérdida',
  sold: 'Vendido',
  isExpress: 'es expreso',
  createdAt: 'Creado en',
  totalCoeff: 'coeficiente total',
  fromUser: 'Del usuario',
  toUser: 'Al usuario',
  from: 'De',
  to: 'A',

  subagents: 'Subagentes',
  newPassword: 'Nueva contraseña',
  oldPassword: 'Contraseña actual',
  repeatPassword: 'Repita la contraseña',
  passwordsDontMatch: '¡Las contraseñas no coinciden!',

  changePermissions: type => `Edición de permisos: ${type} `,
  changePermissionsCasino: 'Permission edit: Casino',
  changePermissionLiveCasino: 'Permission edit: Live Casino',
  changePermissionSport: 'Permission edit: Sport',
  showTheSelectedCategoryForUser: 'Mostrar la categoría seleccionada para el usuario',
  permissionsDetails: 'Detalles de permisos',
  casino: 'Casino',
  sport: 'Deportivas',
  permissions: 'Permisos',
  copyPermissions: 'Copiar permisos a usuarios secundarios',

  total_income: 'Ingreso total',
  incomeAmount: 'Netwin',
  commissionBalance: 'Comisión',
  myCommissionBalance: 'Mi comisión',
  enterTextInLowercaseOnly: 'Introducir texto sólo en minúsculas',

  userNotFound: 'Usuario no encontrado. Compruebe sus credenciales y vuelva a intentar de nuevo.',

  wantToCreateAgent: 'Está seguro, <br/> que quiere crear',
  wantToCreatePlayer: 'Está seguro, <br/> que quiere crear',

  or: 'O',
  retirement: 'Retiro',
  totalDeposit: 'Total depósitos',
  totalWithdrawal: 'Total retiros',
  editAccount: 'Edit account',
  player_agent: 'Jugador/Agente',
  typeOnlyLowercase: 'Introducir texto solo en minusculas',
  resetFilter: 'Restablecer filtro',
  hide: 'Ocultar',
  tree: 'Árbol',
  black: 'Negro',
  gold: 'Oro',
  silver: 'Plata',
  bronze: 'Bronce',
  loadOperations: 'Cargar operaciones',

  all1: 'Todo',
  lastCasinoBets: 'Últimas apuestas de casino',
  deposits: 'Depósitos',
  withdrawals: 'Retiros',
  myCount: 'Movimientos de/a mi cuenta',
  ip: 'IP',
  enterAmount: 'Ingrese la cantidad',
  doYouWantToDepositABonus: '¿Quieres depositar un bono?',
  percent: 'Por ciento %',
  bonus: 'Bonus',
  dataWillBeUpdated: 'Los datos se actualizarán pronto',
  lastUpdateTime: 'Última actualización de los datos',
  currentWeek: 'Semana actual',
  currentMonth: 'Mes actual',

  paymentStatuses: {
    0: 'Depósito',
    1: 'Retiro',
  },
  notification: 'Notificación',
  new: 'Nuevo',
  attention: 'Atención',
  showAll: 'Mostrar todo',
  totalBetCount: 'Cantidad total de apuestas',
  totalBet: 'Total apostado',
  totalWon: 'Total ganado',
  totalIncome: 'Ingreso total',
  netwin: 'Netwin',
  ranking: 'Torneo de cajeros',
  rankingTitle: 'Torneo de cajeros',
  domains: 'Dominios',
  domainFeaturePopupTitle: 'Dominio personalizado',
  domainFeaturePopupSubtitle: '¡Ahora podés solicitar tu dominio personalizado!',
  domainFeaturePopupText1: 'Desde la sección “Dominios”, podés enviar una solicitud para obtener tu propio dominio.',
  domainFeaturePopupText2:
    'La configuración demora entre 1 y 2 días hábiles. Cuando el estado cambie a “Listo”, ya vas a poder usarlo con tus jugadores y agentes.',
  requestDomain: 'Solicitar dominio',
  myDomains: 'Mis dominios',
  requests: 'Solicitudes',
  rankingAdministration: 'Torneo de administradores',
  yourCurrentRank: 'Tu rango actual',
  rankingDescription: 'Suma puntos a medida que generes netwin y\nparticipa por increibles premios!',
  currentRank: 'Tu rango actual:',
  awards: 'Premios',
  top10: 'Top 10',
  currentPosition: 'Tu posición actual {{value}}',
  daysRemaining: 'Número de días restantes hasta el próximo reinicio de calificación mensual',
  rules: 'Tienes dudas? Consulta las reglas de la competencia haciendo ',
  clickHere: 'clic aquí',
  points: 'Puntos:',
  rank: {
    bronze: 'Bronce',
    silver: 'Plata',
    gold: 'Oro',
  },
  table: {
    username: 'Username',
    points: 'Points',
    number: 'Number',
  },

  betDetails: 'Detalles de la apuesta',
  slot: 'Slot',
  summ: 'Suma',
  refId: 'Ref. ID',
  prevBalanceAlt: 'Balance Antes',
  afterBalanceAlt: 'Balance Después',
  playerAlt: 'Nombre',
  idAlt: 'ID de Jugador',
  topOfLastMonth: 'Top del Mes Pasado',
  topOfCurrentMonth: 'Top del Mes Actual',

  settings: 'Ajustes',
  image: 'Imagen',
  active: 'Activa',
  nameGift: 'Nombre del regalo',
  numberOfPoints: 'Número de puntos',
  description: 'Descripción',
  noMore30: 'Máximo 30 caracteres',
  selectFile: 'Seleccione un archivo',
  imageDescription:
    'El tamaño de la imagen no debe superar los 660px*540px, el formato del archivo es png, jpg, webp. El archivo no debe tener fondo.',
  points2: 'Puntos',
  providers: 'Proveedores',
  disable2: 'Desactivar',
  creativeFunctionality: 'Personalización',
  custom: 'Personalizar página',
  customRequests: 'Solicitudes de agentes',
  customRequestStatuses: {
    1: 'Pendiente',
    2: 'Aprobado',
    3: 'Rechazado',
    created: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
  },
  processing: ' En proceso',
  totalProviders: 'Proveedores totales',
  totalGames: 'Juegos totales',
  completed: 'Completado',
  sent: 'Enviado',
  gift: 'Regalo',
  giftManagement: 'Gestión de regalos',
  requestForGift: 'Solicitudes de regalos',
  giftNotFound: 'Regalo no encontrado',
  bonusProgram: 'Programa de bonos',
  programaDeBonificacion: 'Programa de bonificación',
  createPromotions: 'Crear promociones',
  addPromotion: 'Añadir promoción',
  language: 'Idioma',
  status: 'status',
  active: 'Activo',
  inactive: 'Inactivo',
  image: 'Imagen',
  url: 'URL',
  publicationDate: 'Fecha de publicación',
  deactivationDate: 'Fecha de desactivación',
  manage: 'Administrar',
  actionCreation: 'Creación de acciones',
  title: 'Título',
  buttonUrl: 'URL del botón "¡Empieza a jugar!"',
  actionCall: 'Llamada a la acción',
  descriptionBrief: 'Descripción breve',
  descriptionComplete: 'Descripción completa',
  previewImage: 'Imagen de vista previa de la promoción',
  previewImageDescription:
    'El tamaño de la imagen no debe exceder los 1070px*460px, los formatos permitidos son png, jpg, webp.',
  banner: 'Banner de la promoción',
  bannerDescription:
    'El tamaño de la imagen no debe exceder los 1700px*560px, los formatos permitidos son png, jpg, webp.',
  bannerImage: 'Imagen del banner de la promoción',
  bannerImageDescription:
    'The image size should not exceed 1700px*560px, the file format is png, jpg, webp. The file should not have a background.',

  rankings: {
    [rankTypes.bronze]: 'Torneo de cajeros',
    [rankTypes.silver]: 'Torneo de administradores',
    [rankTypes.providerSilver]: 'Proveedores Silver',
    [rankTypes.providerGold]: 'Torneo de Proveedores Gold',
  },
  tournamentOf: 'Torneo de ',
  compare: 'Comparar',
  standardValues: 'Valores estándar',
  address: 'Dirección',
  pragmaticTournament: 'Torneo de Pragmatic Play',
  topAgents: 'Top Agentes',
  leaderBoard: 'Leaderboard',
  peugeotByPragmatic: 'Peugeot 208 by Pragmatic Slots',
  motoByPragmatic: 'Moto Bajaj Rouser by Pragmatic Live',
  pragmaticSlotsAwards: 'Pragmatic Slots Premios',
  pragmaticLiveAwards: 'Pragmatic Live Premios',

  precedingDay: 'Día anterior',
  sameDayLastWeek: 'Mismo día de la semana pasada',
  sameDayLastMonth: 'Mismo día del mes pasado',
  precedingWeek: 'Semana anterior',
  fourWeeksAgo: 'Hace cuatro semanas',
  sameWeekLastMonth: 'Misma semana del mes pasado',
  precedingMonth: 'Mes anterior',
  precedingPeriod: 'Período anterior',
  samePeriodLastMonth: 'Mismo período del mes pasado',
  manualCompare: 'Comparación manual',
  activeUsers: 'Usuarios activos',
  rtp: 'RTP',
  schedule: 'Cronograma',
  saveFilters: 'Guardar filtros',
  savedFilters: 'Filtros guardados',
  filterName: 'Nombre del filtro',
  filterDescription: 'Descripción breve',
  showLess: 'Mostrar menos',
  periodNotSpecified: 'Período no especificado',
  noDescription: 'Sin descripción',
  deleteFilter: 'Eliminar filtro',
  noSavedFilters: 'Todavía no guardaste ningún filtro',
  showSchedule: 'Mostrar gráfico',
  filters: 'Filtros',
  numberOfBets: 'Número de apuestas',
  totalWinnings: 'Ganancias totales',
  selectAtLeastOneMetric: 'Seleccione al menos una métrica.',
  top10PlayersByNetwin: 'Top 10 jugadores por NetWin',
  top5BiggestWins: 'Top 5 mayores ganancias',
  rankColumn: 'Posición',
  previousPeriod: 'Período anterior',
  noDataForSelectedPeriod: 'No hay datos para el período seleccionado',
  toPreviousPeriod: 'respecto al período anterior',
  margin: 'Margen',
  classification: 'Clasificación',
  creativeFunctionality: 'Personalización',
  cashbackCreation: 'Creación de cashback',
  createNewCashback: 'Crear nuevo reembolso',
  providerType: 'Tipo de Proveedor',
  casino: 'Casino',
  sport: 'Deportes',
  slots: 'Tragamonedas',
  numberOfDays: 'Número de días',
  percentReembolso: '% Reembolso',
  toAllPlayers: 'A todos los jugadores',
  onTheSlots: 'En las tragamonedas',
  onSport: 'En deportes',
  conditions: 'Condiciones',
  amount: 'Monto',
  allPlayers: 'Todos los jugadores',
  cashbackList: 'Lista de Cashback',
  days: 'días',
  searchCashback: 'Buscar cashback',
  delete: 'Eliminar',
  selectPlayer: 'Seleccionar jugador',
  cashbackCreatedSuccess: 'Cashback creado exitosamente',
  cashbackDeletedSuccess: 'Cashback eliminado exitosamente',
  cashbackCreationTitle: 'Creación de cashback',
  active: 'Activo',
  completed: 'Completado',
  cancelled: 'Cancelado',

  // requests
  playerDeposits: 'Peticiones de jugadores',
  requisites: 'Requisitos',
  editRequisites: 'Editar requisitos',
  cbu: 'CBU',
  amount: 'Cantidad',
  comment: 'Comentario',
  nameUsers: 'Titular de tu billetera',
  action: 'Acción',
  notes: 'Notas',
  betId: 'Apuesta ID',
  balanceActual: 'Saldo real',
  phone: 'Teléfono',
  advertising: 'PUBLICIDAD',
  copiedSuccessfully: `Copiado con éxito`,
  parentID: 'Parent ID',

  bankDetails: 'Datos bancarios',
  minimalDeposit: 'Depósito mínimo',
  deleteBankDetails: 'Eliminar datos bancarios',
  details: 'Detalles',
  bank: 'Banco',
  additionalInfo: 'Información adicional',
  owner: 'Propietario',
  semiAutoWithdrawalEnabled: '<span>Depósito</span> y <span>retirada</span> semiautomáticos',
  contactWithPlayers: 'Contacto con los jugadores',

  // request history
  requestHistory: 'Historial de peticiones',
  whatsapp: 'Whatsapp',
  holderOfYourWallet: 'Titular de tu billetera',
  generateStrongPassword: 'Generar contraseña fuerte',

  changePasswordFirsLog: 'Aviso importante: Por favor, actualice su contraseña',
  securePassword: 'Generar una contraseña segura',

  referralPlayers: 'Jugadores de referencia',
  invitePlayer: 'Invitar a un jugador',
  referralCodeNotFound: 'Código de referencia no encontrado',
  addFeedbackLink: 'Agregar enlace de contacto',

  cashbackHistory: 'Historial de cashback',
  activateCashback: 'Activar cashback',
  deactivateCashback: 'Desactivar cashback',
  cashbackTerms: 'Términos de cashback y condiciones',
  paidCashback: 'Cashback pagado',
  accumulatedCashback: 'Cashback acumulado',
  cashbackToBePaid: 'Cashback a pagar',
  activateForItsUsers: 'Activar para sus usuarios',
  activateForEntireStructure: 'Activar para toda la estructura',
  deactivateForItsUsers: 'Desactivar para sus usuarios',
  deactivateForEntireStructure: 'Desactivar para toda la estructura',
  playersOnly: 'Solo jugadores',
  agentOnly: 'Solo agentes',
  areYouSureYouWantToActivateCashback: '¿Estás seguro de querer activar el cashback?',
  yes: 'Sí',
  no: 'No',
  promoCodePercent: 'Código promocional aplicado. Bonificación del <percent>% sobre el monto del depósito',

  contactLinkText: 'Agregar enlace de contacto',
  link: 'Link',
  changesSaved: 'Cambios guardados',
  contactFullLinkText: 'Agregá un enlace para que los jugadores puedan contactarte directamente',

  holder: 'Titular',
  statusesForPayment: { 1: 'Confirmado' },
  activateDepositsAndWithdrawalsForPlayers: 'Activar depósitos y retiros para jugadores',
  // statistic - balance
  actualBalance: 'Saldo actual',
  startBalance: 'Saldo inicial',
  endBalance: 'Saldo final',
  changeBalance: 'Cambio de saldo',
  readMore: 'Leer más',
  agentsBalance: 'Balance de Agentes',
  playersBalance: 'Balance de Jugadores',
  notifications: 'Notificaciones',
  totalNotifications: 'Total de notificaciones',
  notificationText: 'Texto de notificación',
  enterNotificationText: 'Ingresá el texto de la notificación',
  sendToConfirm: 'Enviar para confirmar',

  requestForChangeOfNotifications: 'Solicitud de cambio de notificaciones',

  insertLinkToSocialMedia: 'Inserta un enlace a una red social',
  add: 'Agregar',
  insertASocialMediaLinkToAddIt: 'Inserta un enlace a redes sociales para añadirlo',
  requestForChangeOfSocialMedia: 'Solicitud de cambio de redes sociales',
  wasLink: 'Fue enlace',
  becameLink: 'Se convirtió en enlace',
  totalSocialMedia: 'Redes sociales totales',
  social_link: 'Enlace social',
  wasNotifications: 'Texto de notificación',
  became: 'Se convirtió',
  notActive: 'No activo',
  was: 'Fue',
  itemActive: 'Active',
  itemDisabled: 'Disabled',
  valuePlace: '<value> place',
  christmasTournamentTitle: 'Torneo Navideño',
  christmasTournament: {
    title: 'Torneo Navideño',
    description: 'Gana puntos a medida que generas netwin y compite por increíbles premios!',
    prizes: 'Premios',
    points: 'Puntos:',
    positionValue: 'Tu posición actual <value>',
    timeUntil: 'Número de días restantes hasta el próximo reinicio de la clasificación mensual',
    rulesText: '¿Tienes dudas? Consulta las reglas de la competencia haciendo',
    clickHere: 'clic aquí',
    number: 'Número',
    username: 'Usuario',
    pointsH: 'Puntos',
    top10: 'Top 10',
  },
  jacktopTournamentTitle: 'Torneo de Jacktop',
  jacktopTournament: {
    title: 'Torneo de Jacktop',
    description: 'Suma puntos a medida que generes netwin y participa por increibles premios!',
    prizes: 'Premios',
    points: 'Puntos:',
    positionValue: 'Tu posición actual <value>',
    timeUntil: 'Número de días restantes hasta el próximo reinicio de la clasificación mensual',
    rulesText: 'Tienes dudas? Consulta las reglas de la competencia haciendo',
    clickHere: 'click aqui',
    tableHeadLink: 'Top del Mes Pasado',
    number: 'Number',
    username: 'Username',
    points: 'Points',
    top10: 'Top 10',
    topOfCurrentMonth: 'Top del Mes Actual',
    noData: 'Aún no hay datos disponibles',
  },
  rubyPlayTournamentTitle: 'Torneo de Ruby Play',
  rubyPlayTournament: {
    title: 'Torneo de Ruby Play',
    description: 'Suma puntos a medida que generes netwin y participa por increibles premios!',
    prizes: 'Premios',
    points: 'Puntos:',
    positionValue: 'Tu posición actual <value>',
    timeUntil: 'Número de días restantes hasta el próximo reinicio de la clasificación mensual',
    rulesText: 'Tienes dudas? Consulta las reglas de la competencia haciendo',
    clickHere: 'click aqui',
    tableHeadLink: 'Top del Mes Pasado',
    number: 'Number',
    username: 'Username',
    points: 'Points',
    top10: 'Top 10',
    topOfCurrentMonth: 'Top del Mes Actual',
    noData: 'Aún no hay datos disponibles',
  },
  netentTournamentTitle: 'Torneo de Netent',
  netentTournament: {
    title: 'Torneo de Netent',
    description: 'Suma puntos a medida que generes netwin y participa por increibles premios!',
    prizes: 'Premios',
    points: 'Puntos:',
    positionValue: 'Tu posición actual <value>',
    timeUntil: 'Número de días restantes hasta el próximo reinicio de la clasificación mensual',
    rulesText: 'Tienes dudas? Consulta las reglas de la competencia haciendo',
    clickHere: 'click aqui',
    tableHeadLink: 'Top del Mes Pasado',
    number: 'Number',
    username: 'Username',
    points: 'Points',
    top10: 'Top 10',
    topOfCurrentMonth: 'Top del Mes Actual',
    noData: 'Aún no hay datos disponibles',
  },
  settingLimits: 'Configurar límites',
  minimumDeposit: 'Depósito mínimo',
  minimumWithdrawal: 'Retiro mínimo',

  spanish: 'Español',
  portuguese: 'Portugués',
  createActions: 'Creación de acciones',
  status: 'Estado',
  promotions: 'Promociones',
  url: 'URL del botón "¡Empieza a jugar!"',
  callToAction: 'Llamada a la acción',
  shortDescription: 'Descripción breve',
  fullDescription: 'Descripción completa',
  chooseFile: 'Elegir un archivo',
  promoBanner: 'Banner de la promoción',

  es: 'Español',
  pt: 'Portugués',
  allLanguages: 'Todos idiomas',
  limits: 'Limitaciones',
  digsportLimits: 'Deportes',
  digsportLimitsPlaceholder: 'Límite máximo de apuesta',
  slotsLimits: 'Slots',
  slotsLimitsPlaceholder: 'Límite máximo de apuesta',
  liveCasinoLimits: 'Casino en vivo',
  liveCasinoLimitsPlaceholder: 'Límite máximo de apuesta',
  limitsRulesText: 'Se aplica solo a los jugadores directos del agente',
  limitsChangeButton: 'Cambiar',

  requestDomainDescription1: 'Ingresa el dominio que querés usar',
  requestDomainDescription2: 'Revisaremos tu solicitud y te asignaremos el dominio si está disponible',
  requestDomainDescription3: 'El costo del dominio no debe superar los 10 USD',
  sendRequest: 'Enviar solicitud',
  domain: 'Dominio',
  totalDomains: 'Total dominios',
  domainRequested: 'Dominio solicitado',
  totalRequests: 'Total Solicitudes',

  noDomainsAssigned: 'Aún no tenés dominios asignados',
  noRequests: 'No hay solicitudes aún',
  domainRequested: 'Dominio solicitado',

  passwordRequirementMinLength: 'Mínimo de caracteres: <count>',
  passwordRequirementUppercase: 'Mínimo de mayúsculas (A-Z): <count>',
  passwordRequirementSpecial: 'Mínimo de caracteres especiales: <count>',
  passwordRequirementNumber: 'Mínimo de números (0-9): <count>',
  passwordRequirementsText: 'La nueva contraseña debe cumplir estos requisitos: <requirements>.',
  repeatNewPassword: 'Repetir nueva contraseña',
  passwordRequirementsTooltip: 'Requisitos de la contraseña:\n<requirements>',
  passwordInfo: 'Requisitos de la contraseña',
  invalidOldPassword: 'La contraseña actual es incorrecta.',

  surveyIntroTitle: 'Ayudanos a hacer que Ganamos sea más rentable para vos',
  surveyIntroText1: 'Queremos seguir mejorando Ganamos para que puedas ganar más.',
  surveyIntroText2: 'Tu opinión es muy importante. La encuesta es anónima y te va a llevar menos de 2 minutos.',
  surveyStart: 'Dar mi opinión',
  surveyBack: 'Atrás',
  surveyNext: 'Siguiente',
  surveyThanksTitle: '¡Gracias!',
  surveyThanksText: 'Tus respuestas nos ayudan a mejorar Ganamos y el panel de agentes.',
  surveyFinish: 'Finalizar',
};
